module.exports = "query getAzureAuthUrl($url:String!){getAzureAuthUrl(url:$url)}"